import { render, staticRenderFns } from "./provider-create.vue?vue&type=template&id=81806ea2&"
import script from "./provider-create.vue?vue&type=script&lang=js&"
export * from "./provider-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports